import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from '@/app/App.vue'
import router from '@/router'
import { bootstrap } from '@/app/bootstrap'
import '@/styles/main.css'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

// Prime the CSRF cookie and resolve the session before the first guarded navigation, then mount.
bootstrap(pinia).finally(() => {
  app.mount('#app')
})
